import React from 'react';
import { Body1, Body5, Container } from '@ui';
import { Working } from '@ui/Working';
import { useApiKeys } from '@hooks/features/useApiKeys';
import { useConfirmationModal } from '@hooks/application/useConfirmationModal';
import { CreateApiKeyForm } from './CreateApiKeyForm';
import { ApiKeyRevealBox } from './ApiKeyRevealBox';
import { ApiKeyList } from './ApiKeyList';

const RevokeConfirmBody = ({ name }) => (
  <div>
    <Container bottom={12}>
      <Body1 bold>Revoke “{name}”?</Body1>
    </Container>
    <Body5>
      Any scripts or integrations using this key will stop working immediately. This can&apos;t be
      undone.
    </Body5>
  </div>
);

// The account-settings "API Keys" body. Rendering is gated upstream
// (useApiKeysEnabled) so this is only mounted for API users.
export const ApiKeysSection = () => {
  const {
    keys,
    isLoading,
    loadError,
    isCreating,
    createError,
    clearCreateError,
    create,
    revealKey,
    dismissReveal,
    revoke,
    revokingId,
  } = useApiKeys();

  // Confirm before the destructive revoke; the actual call runs on "Yes".
  const { ConfirmationModal, onShowModal } = useConfirmationModal(revoke);
  const requestRevoke = (apiKey) => onShowModal(<RevokeConfirmBody name={apiKey.name} />, apiKey.id);

  return (
    <div>
      {ConfirmationModal}
      <Container top={20}>
        <CreateApiKeyForm
          isCreating={isCreating}
          createError={createError}
          onCreate={create}
          onNameChange={clearCreateError}
        />
      </Container>

      {revealKey && (
        <Container top={20}>
          <ApiKeyRevealBox apiKey={revealKey} onDismiss={dismissReveal} />
        </Container>
      )}

      <Container top={28}>
        {isLoading ? (
          <Working noVerticalPadding />
        ) : loadError ? (
          <Body5>{loadError}</Body5>
        ) : (
          <ApiKeyList keys={keys} revokingId={revokingId} onRequestRevoke={requestRevoke} />
        )}
      </Container>
    </div>
  );
};
